import { Button, Drawer, Skeleton } from "antd";
import BranchGSTCard from "./branch_gst_card";
import BranchGstCreateForm from "./branch_gst_create_form";
import { useState, useEffect, useCallback } from "react";
import { fetchBranchGst } from "../../../apis/branch.api";
import { usePermissions } from "../../../custom_hooks/permission/permission_hook";

const BranchGST = () => {
  const [gsts1, setGsts1] = useState<Array<any>>([]);
  const [branch_gst_add_form, setBranchGstAddForm] = useState(false);
  const [reloadTick, setReloadTick] = useState(0);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = usePermissions();

  const letUpdate = useCallback(() => {
    setReloadTick((t) => t + 1);
  }, []);

  const showBranchGstAddDrawer = useCallback(() => {
    setBranchGstAddForm(true);
  }, []);

  const onGstAddDrawerClose = useCallback(() => {
    setBranchGstAddForm(false);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchBranchGst()
      .then((res) => {
        if (!cancelled) setGsts1(res ?? []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reloadTick]);

  return (
    <div className=" p-3 py-2">
      <div className="d-flex justify-content-between align-items-center pb-3">
        <div className="th-font-size-18 th-font-weight-600 primary-color-text align-middle">
          <div> GST</div>
        </div>
        <div>
          <Button
            size="middle"
            className="fw-bold"
            type="primary"
            disabled={!hasPermission("branch_details.create")}
            onClick={showBranchGstAddDrawer}
          >
            Add GST
          </Button>
        </div>
      </div>
      <div className="row gap-3">
        {loading && gsts1.length === 0 ? (
          <Skeleton active paragraph={{ rows: 3 }} />
        ) : (
          gsts1?.map((gst) => (
            <BranchGSTCard key={gst.id} gst={gst} letUpdate={letUpdate} />
          ))
        )}
      </div>
      <Drawer
        title="Add Gst"
        placement="right"
        closable={false}
        onClose={onGstAddDrawerClose}
        open={branch_gst_add_form}
        destroyOnClose
      >
        <BranchGstCreateForm
          closeDrawer={onGstAddDrawerClose}
          letUpdate={letUpdate}
        />
      </Drawer>
    </div>
  );
};

export default BranchGST;
